export const ANALYTICS_ACTION_TYPES = {
  INDICATION_CHOSEN: 'INDICATION_CHOSEN',
  STEP_BACK: 'STEP_BACK',
  STEP_NEXT: 'STEP_NEXT',
  STEP_SKIP: 'STEP_SKIP',
};
